import { render, staticRenderFns } from "./ConfirmUnpublishDialog.vue?vue&type=template&id=53bfbf46&"
import script from "./ConfirmUnpublishDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmUnpublishDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports